import * as Sentry from "@sentry/vue";

function getRouteContext(router) {
  const route = router && router.currentRoute;
  const fullPath = route && route.fullPath;
  const path = route && route.path;
  const name = route && route.name;
  const hash = window.location.hash;

  return {
    fullPath: fullPath || hash.replace(/^#/, "") || window.location.pathname,
    path: path || "",
    name: name || "",
    hash
  };
}

function setRouteScope(router) {
  const routeContext = getRouteContext(router);

  Sentry.configureScope(scope => {
    scope.setTag("route.fullPath", routeContext.fullPath);
    scope.setTag("route.name", routeContext.name);
    scope.setContext("vueRoute", routeContext);
  });
}

export function initSentry(Vue, router) {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  Sentry.init({
    Vue,
    dsn: "https://850c04dc790dba462c319ad5a51f5258@sentry.ai-tax.cn/5",
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router })
    ],
    tracesSampleRate: 1.0, // 采样率，生产环境可适当降低
    beforeSend(event) {
      const routeContext = getRouteContext(router);

      event.tags = {
        ...event.tags,
        "route.fullPath": routeContext.fullPath,
        "route.name": routeContext.name
      };
      event.contexts = {
        ...event.contexts,
        vueRoute: routeContext
      };

      return event;
    },
    ignoreErrors: [
      // 可添加需要忽略的错误类型
      // "Network Error",
      // "Script error."
    ]
  });

  setRouteScope(router);

  router.afterEach(() => {
    setRouteScope(router);
  });
}

// 导出Sentry实例供其他地方使用
export default Sentry;
